<ng-container *transloco="let t;">
    <div class="d-flex justify-content-start align-items-center">
        <div class="d-inline me-1">
        <ng-container *ngTemplateOutlet="filterTemplate; context: {
            status: PlaybookGuidelineStatusEnum.MET,
            color: 'bg-success',
            isActive: !status || status?.includes(PlaybookGuidelineStatusEnum.MET),
            text: t('Met guideline run filter text (Playbook run filter on Legal Hub right menu ) - Met')
        }"></ng-container>
        </div>

        <div class="d-inline me-1">
        <ng-container *ngTemplateOutlet="filterTemplate; context: {
            status: PlaybookGuidelineStatusEnum.NOT_MET,
            color: 'bg-danger',
            isActive: !status || status?.includes(PlaybookGuidelineStatusEnum.NOT_MET),
            text: t('Not Met guideline run filter text (Playbook run filter on Legal Hub right menu ) - Not Met')
        }"></ng-container>
        </div>

        <div class="d-inline me-1">
        <ng-container *ngTemplateOutlet="filterTemplate; context: {
            status: PlaybookGuidelineStatusEnum.MISSING,
            color: 'bg-secondary',
            isActive: !status || status?.includes(PlaybookGuidelineStatusEnum.MISSING),
            text: t('Missing guideline run filter text (Playbook run filter on Legal Hub right menu ) - Missing')
        }"></ng-container>
        </div>
    </div>
</ng-container>

<ng-template #filterTemplate let-statusToSet="status" let-color="color" let-text="text" let-isActive="isActive">
        <div class="drag-fields-inner-container checkbox-field-inner-container fields-ele-container btn" (click)="filterByStatus(statusToSet)">
            <div class="checkbox-field-box text-white" [ngClass]="isActive? color : ''">
                   <i [data-feather]="'check'" class="cursor-pointer checkbox-checkIcon" [ngClass]="{'hidden':!isActive}" style="width: 14, height: 14" ></i>
            </div>
            <span class="field-label checkbox-field-label selected-label">{{text}} </span>
        </div>
</ng-template>
